export default __webpack_public_path__ + "static/media/disabled-new-icon.134c819f.svg";